import {DEPARTMENTS, Department} from '../data/interfaces';

export const DEPARTMENT_ROUTE_PATH_BY_DEPARTMENT: Record<Department, string> = {
  [DEPARTMENTS.installation]: 'installation',
  [DEPARTMENTS.customerService]: 'customer-service',
  [DEPARTMENTS.assembly]: 'assembly',
  [DEPARTMENTS.production]: 'production',
};
